export default "__VITE_ASSET__D9xNrUtq__"